export default __webpack_public_path__ + "static/media/Gesture_white_Rub-18.a8c63612.svg";